import React, { useEffect, useState } from 'react';
import { walletAPI } from './SellerApi';

export const SellerWallet = () => {
  const [balance, setBalance] = useState(null);
  const [txns, setTxns] = useState([]);
  const [bank, setBank] = useState(null);
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [bankEdit, setBankEdit] = useState(false);
  const [bankForm, setBankForm] = useState({ account_holder: '', bank_name: '', account_number: '', ifsc: '', upi_id: '' });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([walletAPI.balance(), walletAPI.transactions(), walletAPI.bankDetails()])
      .then(([b, t, bk]) => { 
        setBalance(b.data); 
        setTxns(t.data || []); 
        setBank(bk.data); 
        if (bk.data) setBankForm(bk.data); 
      })
      .catch(() => {
        setBalance({ available: 18400, pending: 4200 });
        setTxns([
          { id: 1, type: 'credit', description: 'Settlement for Order #ATR-9918', amount: 1450, date: '2026-05-15' },
          { id: 2, type: 'payout', description: 'NEFT Payout to Bank Account', amount: 10000, date: '2026-05-12' }
        ]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleWithdraw = async (e) => {
    e.preventDefault();
    if (!amount || amount <= 0 || amount > balance?.available) {
      setError('Invalid withdrawal request amount.');
      return;
    }
    setSaving(true); setError('');
    try {
      await walletAPI.withdraw(amount);
      setSuccess(`Payout request for ₹${amount} submitted successfully!`);
      setBalance(p => ({ ...p, available: p.available - amount }));
      setAmount('');
    } catch (err) {
      setError(err.message || 'Payout request failed.');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveBank = async () => {
    setSaving(true); setError(''); setSuccess('');
    try {
      const res = await walletAPI.saveBank(bankForm);
      setBank(res.data || bankForm);
      setBankEdit(false);
      setSuccess('Bank distribution settings updated.');
    } catch (err) {
      setError('Could not update banking rules.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sp-wallet-grid">
      <div className="sp-wallet-main">
        <div className="sp-wallet-cards">
          <div className="sp-w-card primary">
            <span className="sp-w-label">Available for Withdrawal</span>
            <h2>₹{loading ? '...' : balance?.available?.toLocaleString('en-IN')}</h2>
            <form onSubmit={handleWithdraw} style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <input type="number" className="sp-input" placeholder="Amount" value={amount} onChange={e => setAmount(e.target.value)} style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: 'none' }} />
              <button type="submit" className="sp-btn-primary" style={{ background: '#fff', color: '#070d0a' }} disabled={saving}>Request Payout</button>
            </form>
          </div>
          <div className="sp-w-card secondary">
            <span className="sp-w-label">Escrowed Balance</span>
            <h2>₹{loading ? '...' : balance?.pending?.toLocaleString('en-IN')}</h2>
            <p style={{ fontSize: 11, color: 'var(--t3)', marginTop: '0.5rem' }}>Clears automatically on delivery validation cycle</p>
          </div>
        </div>

        {error && <div className="sp-alert danger" style={{ marginTop: '1rem' }}>{error}</div>}
        {success && <div className="sp-alert success" style={{ marginTop: '1rem' }}>{success}</div>}

        <div className="sp-card" style={{ marginTop: '1.5rem' }}>
          <div className="sp-card-title">Transaction Audit Ledger</div>
          <div className="sp-table-wrap">
            <table className="sp-table">
              <tbody>
                {txns.map(t => (
                  <tr key={t.id}>
                    <td>
                      <div style={{ fontWeight: 600, color: 'var(--t1)' }}>{t.description}</div>
                      <div style={{ fontSize: 11, color: 'var(--t3)' }}>{t.date}</div>
                    </td>
                    <td className={`td-align-right ${t.type === 'credit' ? 'td-em' : 'td-gold'}`} style={{ textAlign: 'right', fontWeight: 700 }}>
                      {t.type === 'credit' ? '+' : '-'} ₹{t.amount}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="sp-wallet-side">
        <div className="sp-card">
          <div className="sp-card-title">Settlement Destination</div>
          {bankEdit || !bank ? (
            <div className="sp-form-grid">
              {[['account_holder', 'Holder Name'], ['bank_name', 'Bank Name'], ['account_number', 'Account Number'], ['ifsc', 'IFSC Code']].map(([k, l]) => (
                <div key={k} className="sp-input-group">
                  <label className="sp-label">{l.toUpperCase()}</label>
                  <input className="sp-input" value={bankForm[k] || ''} onChange={e => setBankForm({ ...bankForm, [k]: e.target.value })} />
                </div>
              ))}
              <button className="sp-btn-primary" onClick={handleSaveBank} disabled={saving}>Save Settlement Rule</button>
            </div>
          ) : (
            <div>
              {[
                ['Account Holder', bank.account_holder],
                ['Bank Name', bank.bank_name],
                ['Account No.', `**** **** ${bank.account_number?.slice(-4)}`],
                ['IFSC Route', bank.ifsc]
              ].map(([l, v]) => (
                <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.75rem 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ fontSize: 12, color: 'var(--t3)' }}>{l}</span>
                  <span style={{ fontSize: 13, fontWeight: 600 }}>{v}</span>
                </div>
              ))}
              <button className="sp-btn-secondary" style={{ width: '100%', marginTop: '1rem' }} onClick={() => setBankEdit(true)}>Change Core Bank Settings</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};